// Marca de ESTA instancia. El build del frontend es el mismo para todas, así que el nombre
// y el logo no pueden venir compilados: los sirve el backend en /api/brand.
//
// Se cachea en localStorage porque el login se dibuja ANTES de que vuelva el fetch: sin
// cache, el usuario de un cliente ve "AyudaTecno" por medio segundo y después el nombre de
// su colegio. Ese parpadeo es exactamente lo que un white-label no puede tener.
const CLAVE = 'brand_v1';
const DEFECTO = { name: 'AyudaTecno', tagline: 'HelpDesk', logoUrl: '/logo.jpg', esAyudaTecno: true };

let actual = DEFECTO;
try { const g = JSON.parse(localStorage.getItem(CLAVE) || 'null'); if (g?.name) actual = g; } catch { /* primera vez */ }
// Desde el cache, para que no parpadee nuestro nombre antes de que vuelva /api/brand.
aplicarTitulo(actual);

// El <title> del index.html está compilado ("AyudaTecno HelpDesk") y es el MISMO build para
// todas las instancias: sin esto, el agente de un colegio ve nuestra marca en la pestaña del
// navegador en todas las pantallas, y en el nombre del acceso directo si lo instala.
export function aplicarTitulo(b) {
  try {
    const t = `${b.name}${b.tagline ? ' ' + b.tagline : ''}`.trim();
    if (t && document.title !== t) document.title = t;
  } catch { /* SSR / entorno sin document */ }
}

export function getBrand() { return actual; }

// ¿Este módulo forma parte de ESTA instancia? Es el gate de instancia SOLO, sin mirar el rol
// ni los permisos del usuario — sirve para menús que hoy no filtran nada (la barra inferior
// de mobile tenía la lista escrita a mano) sin cambiarle nada a nuestra instancia, donde no
// hay lista de módulos y por lo tanto todo pasa.
export function instanciaTiene(clave) {
  const mods = actual?.modules;
  if (!mods || !clave) return true;
  const limpia = String(clave).replace(/^group_/, '');
  return mods.includes(clave) || mods.includes(limpia);
}

export async function cargarBrand() {
  try {
    const r = await fetch('/api/brand');
    if (!r.ok) return actual;
    const b = await r.json();
    if (b?.name) {
      actual = b;
      // Las traducciones usan {{marca}}: hay que avisarles, si no siguen diciendo el
      // nombre cacheado (o el nuestro) hasta el próximo refresh.
      try { require('../i18n').actualizarMarcaI18n(b.name); } catch { /* i18n aún no cargó */ }
      aplicarTitulo(b);
      try { localStorage.setItem(CLAVE, JSON.stringify(b)); } catch { /* modo privado */ }
    }
  } catch { /* sin red: queda lo cacheado o el default */ }
  return actual;
}
